import { palette } from "../assets/theme/theme";


export const CardStyle = {
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 10,
    borderColor: palette.gray.medium,
    padding: 40,
    boxShadow: '0px 4px 6px -2px #b2b8c2'
}